import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Blogs.css";
import innerbanner from "../assets/images/blog-banner.png";
import { fetchAPI } from "../utils/api";

export default function Blogs() {
  const [visibleBlogs, setVisibleBlogs] = useState(6);
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);

  const handleLoadMore = () => {
    setLoading(true);

    setTimeout(() => {
      // Show all remaining blogs
      setVisibleBlogs(blogs.length);
      setLoading(false);
    }, 1000);
  };

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };

  useEffect(() => {
    fetchAPI("blog")
      .then((res) => {
        if (res.status === 200 && res.result) {
          setBlogs(res.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
      });
  }, []);

  return (
    <>
      <Header />

      <div className="main_blogs_conatiner">
        <div className="container-fluid">
          <div
            className="inner_banner_contact"
            style={{ backgroundImage: `url(${innerbanner})` }}
          >
            <div className="text_on_img">
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span> &gt; </span>
                <Link to="/blogs">Blogs</Link>
              </div>

              <h1 className="bread_heading">Blogs</h1>

              <p className="bread_peraa">
                Explore helpful guides, practical tips, and useful insights
                about medical equipment rentals, product usage, and choosing the
                right equipment for your home needs.
              </p>
            </div>
          </div>

          <div className="blog_section">
            <div className="row">
              {blogs.length === 0 ? (
                <div className="col-12 text-center py-5">
                  <p>No blogs available at the moment.</p>
                </div>
              ) : (
                blogs.slice(0, visibleBlogs).map((blog) => (
                  <div className="col-lg-4 col-md-6 col-12" key={blog.blog_id}>
                    <div className="blogs_main_box">
                      <img src={blog.blog_fimage} alt={blog.blog_title} />

                      <div className="date-text">
                        <span>
                          {blog.blog_created
                            ? new Date(blog.blog_created).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : ""}
                        </span>
                      </div>

                      <h3>{blog.blog_title}</h3>

                      <p>
                        {blog.blog_description
                          ? stripHtml(blog.blog_description).substring(0, 120) +
                            "..."
                          : ""}
                      </p>

                      <div className="detail_link">
                        <Link to={`/blog/${blog.blog_slug}`}>Read More...</Link>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>

      {/* LOAD MORE */}

      {visibleBlogs < blogs.length && (
        <div className="text-center mb-5">
          {!loading ? (
            <button className="main_btn" onClick={handleLoadMore}>
              Load More
            </button>
          ) : (
            <button className="main_btn" disabled>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Loading...
            </button>
          )}
        </div>
      )}

      <Footer />
    </>
  );
}
